<template>
    <div class="s2w-workspace-folder-selector-container">
        <div class="s2w-select-folder-label">
            <span class="selector-label">{{ $t('BaseSaveToWorkspace.FolderSelector.label') }}</span>
        </div>
        <div class="s2w-workspace-folder-selector">
            <div
                v-if="folderSelector.enableFoldersSearch"
                class="s2w-search-input"
            >
                <div class="input-item">
                    <div class="search-target">
                        <div
                            class="search-switch-btn"
                            :class="[folderSelector.searchType]"
                            @click="toggleSearchType"
                        >
                            <PtIcon
                                class="search-switch-icon"
                                icon="SolidSwitchType"
                                style="font-size: 20px;"
                            />
                            <span>
                                {{ $t(`BaseSaveToWorkspace.FolderSelector.searchType.${folderSelector.searchType}`) }}
                            </span>
                        </div>
                    </div>
                    <input
                        v-model.trim="folderSelector.searchKeywords"
                        :placeholder="$t('BaseSaveToWorkspace.FolderSelector.placeholder')"
                        maxlength="40"
                        @keypress.enter="onKeypressEnter"
                        @input="onKeywordsInput"
                    >
                </div>
                <PtIcon
                    v-if="folderSelector.searchKeywords"
                    class="clear-btn"
                    icon="SolidCloseMedium"
                    style="font-size: 16px;"
                    @click="clearSearchInput()"
                />
                <PtIcon
                    class="search-btn"
                    icon="SolidSearchLeft"
                    style="font-size: 24px;"
                    @click="onKeypressEnter"
                />
            </div>
            <div>
                <div
                    v-if="folderSelector.loading"
                    class="loading-pane"
                >
                    <PtIcon
                        icon="SolidLoadingBars"
                        style="font-size: 48px;"
                    />
                </div>
                <WorkspaceList v-else-if="folderSelector.workspaceList && folderSelector.workspaceList.length" />
                <div
                    v-else
                    class="no-data-pane"
                >
                    <PtIcon
                        icon="SolidNoDataTip"
                        style="font-size: 40px;"
                    />
                    <div>{{ noSpaceTip }}</div>
                </div>
            </div>
            <div
                class="add-workspace-btn"
                @click="service.addWorkspace()"
            >
                <PtIcon
                    icon="SolidAddMedium"
                    style="font-size: 24px;"
                />
                {{ $t('BaseSaveToWorkspace.FolderSelector.addWorkspace') }}
            </div>
        </div>
    </div>
</template>

<script>
import get from 'lodash/get';
import PtIcon from '@patsnap-biz/icon';
import WorkspaceList from './WorkspaceList';
import '@patsnap-ui/icon/assets/solid/CloseMedium.svg';
import '@patsnap-ui/icon/assets/solid/AddMedium.svg';
import '@patsnap-ui/icon/assets/solid/SearchLeft.svg';
import '@patsnap-ui/icon/assets/solid/LoadingBars.svg';
import '@patsnap-ui/icon/assets/solid/NoDataTip.svg';
import '@patsnap-ui/icon/assets/solid/SwitchType.svg';
import { SearchType } from '../../BasicService';

export default {
    name: 'SaveToWorkspaceFolderSelector',
    components: {
        PtIcon,
        WorkspaceList,
    },
    inject: ['service'],
    computed: {
        folderSelector() {
            return get(this, 'service.folderSelector');
        },
        noSpaceTip() {
            let tip = this.$t('BaseSaveToWorkspace.FolderSelector.noData.workspace');
            if (this.folderSelector.searchKeywords) {
                if (this.folderSelector.searchType === SearchType.WORKSPACE) {
                    tip = this.$t('BaseSaveToWorkspace.FolderSelector.noData.searchSpace');
                } else {
                    tip = this.$t('BaseSaveToWorkspace.FolderSelector.noData.searchFolder');
                }
            }
            return tip;
        },
    },
    methods: {
        toggleSearchType() {
            this.folderSelector.searchType = this.folderSelector.searchType === SearchType.WORKSPACE
                ? SearchType.FOLDER : SearchType.WORKSPACE;
        },
        clearSearchInput() {
            this.folderSelector.searchKeywords = '';
            this.onKeywordsInput();
        },
        onKeywordsInput() {
            if (!this.folderSelector.searchKeywords && this.folderSelector.lastSearchKeywords) {
                this.service.fetchWorkspaces();
            }
        },
        onKeypressEnter() {
            if (!this.folderSelector.searchKeywords) return;
            this.service.fetchWorkspaces();
        },
    },
};
</script>
